



































































import ReactProxy from "@/components/react/react-proxy.react";
import { userService } from "@/services/user";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import DataTable from "@/components/data/data-table.vue";
import ReservationGraph from "@/components/data/reservations-graph.vue";
import { VueProxy, ReservationForm } from "@ciao/vue-proxy";
import { User } from "@/swagger/models";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "reservationCreateModal",
    components: { ReactProxy, ReservationGraph, DataTable, VueProxy },
})
export default class ReservationCreateModal extends Vue {
    @Prop({ required: true })
    userId: number;

    accessToken: string | null = null;
    user: User = null;
    open: boolean = false;

    get ReservationForm() {
        return ReservationForm;
    }

    @Watch("open")
    async refreshData() {
        // We need overflow:visible on the dialog, as the (non-standard) select dropdowns are otherwise cut off
        // However, I could not find a more elegant way to do this. Adding a class, style, id, or anything else to the modal
        // didn't work because the actual modal is created and injected into the DOM separately
        this.$nextTick(() => {
            // Show or hide the page scrollbar
            document.documentElement.style.overflow = this.open ? "hidden" : "scroll";

            const dialog = (<Vue>this.$refs.dialog).$el.parentElement;
            dialog.style.overflow = "visible";
            dialog.style.boxShadow = "none";

            const dialogWrapper = dialog.parentElement;
            dialogWrapper.style.overflowY = "auto";
            dialogWrapper.style.pointerEvents = this.open ? "all" : "none";
            dialogWrapper.addEventListener("wheel", (e) => e.stopPropagation(), true);
            dialogWrapper.addEventListener("click", (e) => {
                if (e.target === dialogWrapper) this.open = false;
            });

            // dialogWrapper.parentElement.querySelector('')
        });

        if (!this.open) return;

        this.user = null; // Clear old data
        try {
            this.accessToken = await this.$auth.getAccessToken();
            this.user = (await userService.getNew(this.userId)).data;
        } catch (e) {
            this.$router.back();
        }
    }

    onReservationCreated() {
        // console.log("onReservationCreated", arguments);
        this.$tosti.success({ message: "Reservation created" });
        this.$emit("save");
        this.open = false;
        // this.$router.back();
    }

    //@todo: assign error type from the api
    onReservationError(error: any) {
        this.$tosti.error({ message: error.message });
    }

    get apiBaseUrl() {
        return process.env.VUE_APP_API_BASE;
    }

    get clientVersion() {
        return `console v${process.env.VUE_APP_PACKAGE_VERSION}`;
    }
}
